import { ProvenanceCategoryCode } from "generated/graphql";

export const provenanceLabelMap: Record<ProvenanceCategoryCode, string> = {
  [ProvenanceCategoryCode.W]: "Wild",
  [ProvenanceCategoryCode.G]: "Garden",
  [ProvenanceCategoryCode.Z]: "Garden - Wild origin",
  [ProvenanceCategoryCode.U]: "Uncertain",
};
